import { combineReducers } from 'redux';

import userAuth from '@reducers/userAuth';
import userListing from '@modules/users/user-listing/reducer';
import verifyUserListing from '@modules/kyc-approval/verify-user-listing/reducer';
import accessCodeListing from '@modules/invite/access-code/reducer';
import downloadAnalyticsReport from '@reducers/downloadAnalyticsReport';
import createDealStates from '@modules/deals/create-deal/reducer';
import dealListing from '@modules/deals/deals-list/reducer';
import syndicateListing from '@modules/syndicate/syndicate-list/reducer';
import breadCrumb from '@reducers/breadCrumb';
import opportunityListing from '@modules/opportunities/opportunities-list/reducers/opportunityList';
import companyListing from '@modules/companies/company-list/reducer';
import dealAnalytics from '@modules/deals/deal-analytics/reducer';
import unVerifiedDocsCount from '@reducers/unverifiedDocsCount';
import aifUnitPrice from '@modules/deals/deal-invite/reducer';
import screeningList from '@modules/screening/screening-list/reducers/screeningListReducer';
import screeningWaitlistedListReducer from '@modules/screening/screening-list/reducers/screeningWaitlistedReducer';
import screeninRejectedListReducer from '@modules/screening/screening-list/reducers/screeninRejectedListReducer';
import screeningPassListReducer from '@modules/screening/screening-list/reducers/screeningPassListReducer';
import screeningAllListReducer from '@modules/screening/screening-list/reducers/screeningAllListReducer';
import subscribedUsersEarlyAccess from '@modules/opportunities/create-early-access/reducer';
import wishlistedUsersReducer from '@modules/opportunities/create-wishlist/reducer';
import downloadSubscribedUsersReport from '@reducers/downloadSubscribedUsersReport';
import downloadWishlistedUsersReport from '@reducers/downloadWishlistedUsersReport';
import transactionsList from '@modules/transaction/transactions-attribution-pending-list/reducers/transactionsListReducer';
import transactionsAttributedList from '@modules/transaction/transactions-attributed-list/reducers/transactionsAttributedListReducer';
import transactionsRefundListReducer from '@modules/transaction/transactions-refund-list/reducers/transactionsRefundListReducer';
import preIPODealsLiveListStateReducer from '@modules/pre-ipo-deals/pre-ipo-deals-live-tab/reducer/preIPODealsLiveListStateReducer';
import preIPODealsClosedListStateReducer from '@modules/pre-ipo-deals/pre-ipo-deals-closed-tab/reducer/preIPODealsClosedListStateReducer';
import preIPOEnquiresListStateReducer from '@modules/pre-ipo-enquires/pre-ipo-enquires-tab/reducer/preIPOEnquiresListStateReducer';
import preIPOEnquiresClosedListStateReducer from '@modules/pre-ipo-enquires/pre-ipo-enquires-closed-tab/reducer/preIPOEnquiresClosedListStateReducer';
import createPreIPODealStates from '@modules/pre-ipo-deals/create-pre-ipo-deals/reducers/createPreIPODealsReducer';
import preIPOCrmListStateReducer from '@modules/pre-ipo-enquires/pre-ipo-crm-tab/reducer/preIPOCrmListStateReducer';
import dealEnquiresListStateReducer from '@modules/deal-enquires/reducer/dealEnquiresListStateReducer';
import userRoleReducer from '@reducers/userRole';
import globalApiSupport from '@reducers/globalApiSupport';
import soaDocumentsStateReducer from '@modules/unit-certificate/upload-section/reducer/soaDocumentsStateReducer';
import unitCertificatesStateReducer from '@modules/unit-certificate/unit-certificates-list/reducer/unitCertificatesSectionStateReducer';

import { store } from './store';

const rootReducer = combineReducers({
  userAuth,
  userListing,
  verifyUserListing,
  accessCodeListing,
  downloadAnalyticsReport,
  createDealStates,
  dealListing,
  syndicateListing,
  breadCrumb,
  opportunityListing,
  companyListing,
  dealAnalytics,
  unVerifiedDocsCount,
  aifUnitPrice,
  screeningList,
  screeninRejectedListReducer,
  screeningWaitlistedListReducer,
  screeningPassListReducer,
  screeningAllListReducer,
  subscribedUsersEarlyAccess,
  wishlistedUsersReducer,
  downloadSubscribedUsersReport,
  downloadWishlistedUsersReport,
  transactionsList,
  transactionsAttributedList,
  transactionsRefundListReducer,
  preIPODealsLiveListStateReducer,
  preIPODealsClosedListStateReducer,
  preIPOEnquiresListStateReducer,
  preIPOEnquiresClosedListStateReducer,
  createPreIPODealStates,
  preIPOCrmListStateReducer,
  dealEnquiresListStateReducer,
  userRoleReducer,
  globalApiSupport,
  soaDocumentsStateReducer,
  unitCertificatesStateReducer
});

export type RootState = ReturnType<typeof store.getState>;

export default rootReducer;
